import gsap from "gsap";
import { TextPlugin } from "gsap/TextPlugin";

// Register the plugin
gsap.registerPlugin(TextPlugin);

document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("mousemove", function (e) {
    let mask = document.querySelector(".header-shadow-2");
    let rect = mask.getBoundingClientRect(); // Get the position of the image container

    let x = e.clientX - rect.left; // Adjust to the mask's coordinates
    let y = e.clientY - rect.top;

    // Update the mask's shape and position based on cursor
    mask.style.webkitMaskImage = `radial-gradient(circle 100px at ${x}px ${y}px, transparent 0%, black 50%)`;
    mask.style.maskImage = `radial-gradient(circle 400px at ${x}px ${y}px, transparent 0%, black 100%)`;
  });

  const words = [
    "Web Development !",
    "Playing Chess !",
    "Walking in the nature !",
  ];
  let index = 0;

  function typeText(text, onComplete) {
    let tl = gsap.timeline({ onComplete });
    tl.set(".header-changing-text", { text: "" });

    for (let i = 0; i < text.length; i++) {
      tl.to(".header-changing-text", {
        text: text.substring(0, i + 1),
        duration: 0.1,
      });
    }

    // Pause before deleting
    tl.to({}, { duration: 1 });

    // Delete text
    for (let i = text.length; i >= 0; i--) {
      tl.to(".header-changing-text", {
        text: text.substring(0, i),
        duration: 0.05,
      });
    }
  }

  function startTypewriter() {
    typeText(words[index], () => {
      index = (index + 1) % words.length;
      startTypewriter();
    });
  }

  startTypewriter();
});
